import Vue from 'vue'

export default Vue.extend({
  template: `
  <div v-if="!params.data.new">
    {{ params.value }}
  </div>
  <div v-else>
    <strong v-b-tooltip.hover title="id будет назначен после сохранения">?</strong>
  </div>
  `
})
